<template>
  <div :class="['groups', displayName ? 'add-row-gap':'']">
    <div
      v-for="(item, index) in sources"
      :key="index"
      style="display: inline-flex; flex-direction: column; align-items: center; vertical-align: top;"
      >
      <div
        class="attachment"
        :style="validationBorderStyle(item)"
        @mouseenter="toggleOverlay($event, true)"
        @mouseleave="toggleOverlay($event, false)"
      >
        <div v-if="isImage(item)" class="background" :style="{'background-image': `url('${imgLoader(item)}')`}"></div>
        <div v-else class="background doc"><img src="@/assets/icon/document.png" alt=""></div>
        <div class="overlay">
          <div class="icons">
            <a :href="imgLoader(item)" target="_blank">
              <i class="material-icons">visibility</i>
            </a>
            <a v-if="deleteAble" @click="deleteAttachment(item)"><i class="material-icons">delete</i></a>
          </div>
        </div>
        <div class="attachment-name" v-if="displayName">{{getAttachmentNames(item)}}</div>
      </div>
      <div
        v-if="validationData[item] && validationData[item].validationStatus === 'invalid' && validationData[item].reason"
        style="color: #EF4444; font-size: 10px; margin-top: 3px; max-width: 80px; text-align: center; line-height: 1.3;"
      >
        {{ validationData[item].reason }}
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@//lib/config.js'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapGettersConfig } = createNamespacedHelpers('config')

export default {
  name: 'oba-attachment',
  emits: ['delete'],
  props: {
    sources: {
      type: Array,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    collection: {
      type: String,
      required: true
    },
    validationData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGettersConfig([
      'getAttachmentNamePermission',
      'getDeletePermission'
    ]),
    displayName(){
      return this.getAttachmentNamePermission(this.collection)
    },
    deleteAble(){
      return this.getDeletePermission(this.collection)
    }
  },
  methods: {
    validationBorderStyle(item) {
      const data = this.validationData[item]
      if (!data) return {}
      if (data.validationStatus === 'valid') return { outline: '2px solid #22C55E', borderRadius: '4px' }
      if (data.validationStatus === 'invalid') return { outline: '2px solid #EF4444', borderRadius: '4px' }
      return {}
    },
    toggleOverlay(event, showOverlay) {
      const overlay = event.currentTarget.querySelector('.overlay')
      if (showOverlay) {
        overlay.classList.add('show')
      } else {
        overlay.classList.remove('show')
      }
    },
    deleteAttachment(url) {
      // TO DO
      // emit id / filename of attachment
      let data = {
        fieldName: this.fieldName,
        link: url
      }
      this.$emit('delete', data)
    },
    imgLoader(path){
      // attachments may be hosted outside Firebase Storage, in which case the
      // value is already a full URL and must not be prefixed
      if (/^https?:\/\//i.test(path)) return path
      return `${config.imgPrefix}${path}`
    },
    isImage(path){
       // ignore any query string or fragment so external CDN URLs still match
       const withoutQuery = path.split(/[?#]/)[0]
       return (withoutQuery.match(/\.(jpg|jpeg|png|gif|webp)$/i))
    },
    getAttachmentNames(value){
      let name = value.replace(/.*[\/\\]/, '')
      return name
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
